import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ContractConcession } from '@classes/contract-concession';
import { map } from 'rxjs/operators';
import { EnvConfigurationService } from './env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ContractConcessionService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/contractConcession';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getContractConcessions(): Observable<Array<ContractConcession>> {
    return this.http.get<Array<ContractConcession>>(this.basePath);
  }

  getContractConcession(id: string): Observable<ContractConcession> {
    return this.http.get<ContractConcession>(`${this.basePath}/${id}`);
  }
  getContractConcessionsByContractID(contractId: string): Observable<Array<ContractConcession>> {
    return this.http.get<Array<ContractConcession>>(`${this.basePath}/GetByContractID?contractId=${contractId}`);
  }

  createOrUpdateContractConcession(contractConcession?: ContractConcession): Observable<ContractConcession> {
    if (contractConcession?.id) {
      //update
      const url = `${this.basePath}/${contractConcession?.id}`;
      return this.http.patch<any>(url,
        contractConcession).pipe(map(m => {
          return m
        }));
    } else {
      //create

      return this.http.post<any>(this.basePath,
        contractConcession
      ).pipe(map(m => {
        return m
      }));
    }
  }

  deleteContractConcession(contractConcessionId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${contractConcessionId}`;
    return this.http.delete(url);
  }
}
